import React, { useContext } from 'react'

import { Carousel } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import imageIngestionData from '../../assets/ingestao_dados_manuais.jpg';
import imageDataLake from '../../assets/what_is_datalake.jpg';

import StoreContext from '../../components/storage/context';

import './styles.css'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const CarouselNews = () => {
    const news = [
        {
            "title": "what is a datalake?",
            "subTitle": "",
            "link": "https://aws.amazon.com/pt/big-data/datalakes-and-analytics/what-is-a-data-lake/?nc=sn&loc=2",
            "image": imageDataLake,
            "external_link": true
        },
        {
            "title": "ingestão de dados manuais",
            "subTitle": "",
            "link": "/cadastro-arq-manual",
            "image": imageIngestionData,
            "external_link": false
        }
    ]

    const { setPKService } = useContext(StoreContext);

    let history = useHistory();
    
    const onClickCarousel = ({url}) => {
        setPKService(1)
        history.push({
            pathname: url,
            search: `?service_id=1`
        });
    }

    const RedirectExternalPage = (url) => {
        window.open(url);
    }

    return (
        <div className="carousel-news-container">
            <Carousel>
                {news.map((item, index) => (
                    <Carousel.Item interval={4000}>
                        {!item.external_link ?
                            <Link to={item.link} onClick={() => onClickCarousel(item.link)}>
                                <img className="carousel-news-image" src={item.image} alt={item.title} />
                            </Link >
                        :
                            <div onClick={() => RedirectExternalPage(item.link)}>
                                <img className="carousel-news-image" src={item.image} alt={item.title} />
                            </div>
                        }

                        <Carousel.Caption>
                            <h3></h3>
                            <p></p>
                        </Carousel.Caption>
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
}

export default CarouselNews;